import React, {Component} from 'react'
import {Col, Card, Row, CardHeader, CardBody, ListGroup} from 'reactstrap'
import {Link} from 'react-router-dom'

class Calculators extends Component {
  render() {
    return (
      <div className="animated fadeIn">
        <Row>
          <Col sm="12" xl="6">
            <Card>
              <CardHeader>
                <span><i className="fa fa-align-justify"/><b>Calculators</b></span>
              </CardHeader>
              <CardBody>
                <ListGroup>
                  <Link to="/calculators/weldability-of-steel">
                    <li className="list-group-item-action list-group-item">Weldability of steel</li>
                  </Link>
                  <Link to="/calculators/material-amount">
                    <li className="list-group-item-action list-group-item">Material amount</li>
                  </Link>
                </ListGroup>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

export default Calculators



// WEBPACK FOOTER //
// ./src/views/Calculators/Calculators.js